export default __webpack_public_path__ + "static/media/ReportImage.6476bad0.png";